export default __webpack_public_path__ + "static/media/Wedging Thorn.6ebf9f4e.png";